<template>
  <tr>
    <td data-test="productLabel">
      <span class="d-block mb-1 font-weight-bold">{{ product.label }}</span>
      <span class="text-muted">{{ getLabelSubtitle(product) }}</span>
    </td>
    <td>{{ product.eanCode }}</td>
    <td>{{ product.brand }}</td>
    <td>{{ product.category.label }}</td>
    <td class="font-weight-bolder">{{ price }}</td>
    <td>
      <span v-if="product.status === PRODUCT_STATUS_DRAFT" class="badge p-3 cirx-chip warning-chip badge-secondary">
        {{ translate("PRODUCT.CREATE_FORM.STATUS_DRAFT") }}
      </span>
      <span v-else class="badge p-3 cirx-chip success-chip badge-secondary">
        {{ translate("PRODUCT.CREATE_FORM.STATUS_PUBLISHED") }}
      </span>
    </td>
    <td aria-colindex="6" role="cell">
      <router-link :to="{ name: routes.editProduct.name, params: { id: product.id } }">
        <button type="button" class="btn ma-2 p-0 cirx-table-action-btn btn-secondary">
          <inline-svg class="svg cirx-custom-primary-color-svg" src="/media/cirx/edit_icon.svg" />
        </button>
      </router-link>
    </td>
  </tr>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { computed } from "vue";
import { Product, PRODUCT_STATUS_DRAFT } from "@/core/models/product";
import { routes } from "@/routing/routes";
import useTranslate from "@/core/composables/translate";

const { translate, localizeCurrency } = useTranslate();

const { product } = defineProps({
  product: Product,
});

const price = computed(() =>
  product.buybackPriceGradeA || product.buybackPriceGradeA === 0 ? localizeCurrency(product.buybackPriceGradeA) : "-"
);

const getLabelSubtitle = (value) => [value.modele, value.reference].filter(Boolean).join(" · ");
</script>

<style scoped></style>
